const ReadOnlyField = ({ label, value }) => {
  return (
    <div className="mb-4">
      <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
        {label}
      </p>

      <p className="text-sm font-medium text-gray-900 dark:text-gray-200">
        {value ?? "—"}
      </p>
    </div>
  );
};

export default ReadOnlyField;
